module.exports = __webpack_public_path__ + "img/webpack.c500a380.png";